/* Tandoori Masala — Diseño F · carrusel, carta (categorías y buscador) y reservas por WhatsApp */
(function () {
  'use strict';
  var T = window.TMF;
  if (!T) return;
  var $ = T.$, $$ = T.$$;

  /* ---- Carrusel ---- */
  $$('[data-tm-carousel]').forEach(function (car) {
    var track = $('[data-tm-track]', car), slides = $$('.tm-slide', car), dots = $$('[data-tm-dot]', car);
    if (!track || slides.length < 2) return;
    var i = 0, last = 0, x0 = null;
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
    }
    function user(n) { last = Date.now(); go(n); }
    $$('[data-tm-prev]', car).forEach(function (b) { b.addEventListener('click', function () { user(i - 1); }); });
    $$('[data-tm-next]', car).forEach(function (b) { b.addEventListener('click', function () { user(i + 1); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { user(k); }); });
    car.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    car.addEventListener('pointerup', function (e) { if (x0 == null) return; var dx = e.clientX - x0; x0 = null; if (dx < -40) user(i + 1); else if (dx > 40) user(i - 1); });
    car.addEventListener('pointercancel', function () { x0 = null; });
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce) setInterval(function () { if (Date.now() - last > 7000 && !document.hidden) go(i + 1); }, 4500);
    go(0);
  });

  /* ---- Carta: categorías, buscador y categoría activa ---- */
  var menu = $('[data-tm-menu]');
  if (menu) {
    var catBtns = $$('[data-tm-cat]', menu), secs = $$('[data-tm-catsec]', menu), ticking = false;
    catBtns.forEach(function (b) {
      b.addEventListener('click', function () { var s = document.getElementById(b.getAttribute('data-tm-cat')); if (s) s.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    });
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var cur = null;
        secs.forEach(function (s) { if (!s.hidden && s.style.display !== 'none' && s.getBoundingClientRect().top < 170) cur = s.id; });
        catBtns.forEach(function (b) {
          var on = b.getAttribute('data-tm-cat') === cur;
          if (on && !b.classList.contains('is-active') && b.parentNode.scrollWidth > b.parentNode.clientWidth) b.scrollIntoView({ block: 'nearest', inline: 'center' });
          b.classList.toggle('is-active', on);
        });
      });
    }, { passive: true });
    var search = $('[data-tm-search]');
    if (search) {
      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        secs.forEach(function (s) {
          var any = false;
          $$('[data-tm-card]', s).forEach(function (c) {
            var match = !q || (c.getAttribute('data-title') || '').indexOf(q) !== -1;
            c.style.display = match ? '' : 'none';
            if (match && !c.hidden) any = true;
          });
          s.style.display = any || !q ? '' : 'none';
        });
        var none = $('[data-tm-noresults]');
        if (none) none.hidden = !q || secs.some(function (s) { return s.style.display !== 'none' && !s.hidden; });
      });
    }
    if (window.location.hash) {
      var target = document.getElementById(window.location.hash.slice(1));
      if (target) setTimeout(function () { target.scrollIntoView({ block: 'start' }); }, 300);
    }
  }

  /* ---- Reservar mesa (se envía por WhatsApp, como en el tema actual) ---- */
  var res = $('[data-tm-res]');
  if (res) {
    var r = { store: null, people: '2', date: '', time: '' };
    var qs = new URLSearchParams(window.location.search);
    if (qs.get('restaurante') && T.storeById(qs.get('restaurante'))) r.store = qs.get('restaurante');
    var dateIn = $('#tm-res-date', res);
    if (dateIn) {
      var now = new Date(), iso = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
      dateIn.min = iso; dateIn.value = iso; r.date = iso;
      dateIn.addEventListener('change', function () { r.date = dateIn.value; draw(); });
    }
    var val = function (id) { var n = $('#' + id, res); return n ? n.value : ''; };
    var niceDate = function (d) {
      if (!d) return '—';
      var p = d.split('-');
      return new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2])).toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' });
    };
    var draw = function () {
      [['data-res-store', r.store], ['data-res-people', r.people], ['data-res-time', r.time]].forEach(function (pair) {
        $$('[' + pair[0] + ']', res).forEach(function (b) { var on = b.getAttribute(pair[0]) === pair[1]; b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      });
      var st = T.storeById(r.store);
      var set = function (k, v) { var n = $('[data-res-sum="' + k + '"]', res); if (n) n.textContent = v; };
      set('store', st ? st.name : '—'); set('people', r.people === '8' ? '8 o más' : r.people); set('date', niceDate(r.date)); set('time', r.time || '—');
      var missing = !st ? 'Elige restaurante' : !r.date ? 'Elige el día' : !r.time ? 'Elige la hora' : !val('tm-res-name').trim() ? 'Escribe tu nombre' : !val('tm-res-phone').trim() ? 'Escribe tu teléfono' : '';
      var btn = $('[data-res-send]', res);
      if (btn) { btn.textContent = missing || 'Enviar reserva por WhatsApp'; btn.classList.toggle('is-disabled', !!missing); btn.setAttribute('data-ok', missing ? '0' : '1'); }
    };
    res.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('[data-res-store]'))) { r.store = b.getAttribute('data-res-store'); draw(); }
      else if ((b = e.target.closest('[data-res-people]'))) { r.people = b.getAttribute('data-res-people'); draw(); }
      else if ((b = e.target.closest('[data-res-time]'))) { r.time = b.getAttribute('data-res-time'); draw(); }
      else if ((b = e.target.closest('[data-res-send]'))) {
        e.preventDefault();
        if (b.getAttribute('data-ok') !== '1') return;
        var st = T.storeById(r.store);
        var msg = 'Reserva Mesa\nRestaurante: ' + st.name + '\nPersonas: ' + (r.people === '8' ? '8 o más' : r.people) + '\nFecha: ' + niceDate(r.date) + '\nHora: ' + r.time +
          '\nNombre: ' + val('tm-res-name') + '\nTeléfono: ' + val('tm-res-phone') + '\nComentarios: ' + val('tm-res-note');
        window.open('https://wa.me/' + T.CFG.whatsapp + '?text=' + encodeURIComponent(msg), '_blank');
        var done = $('[data-res-done]', res), form = $('[data-res-form]', res);
        if (done && form) {
          form.hidden = true; done.hidden = false;
          var n = $('[data-res-done-name]', done); if (n) n.textContent = val('tm-res-name').split(' ')[0];
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      } else if (e.target.closest('[data-res-again]')) {
        $('[data-res-form]', res).hidden = false; $('[data-res-done]', res).hidden = true; r.time = ''; draw();
      }
    });
    res.addEventListener('input', draw);
    draw();
  }
})();